import { render, staticRenderFns } from "./yieldDetailTabsOne.vue?vue&type=template&id=2ca1a410&scoped=true&"
import script from "./yieldDetailTabsOne.vue?vue&type=script&lang=js&"
export * from "./yieldDetailTabsOne.vue?vue&type=script&lang=js&"
import style0 from "./yieldDetailTabsOne.vue?vue&type=style&index=0&id=2ca1a410&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca1a410",
  null
  
)

export default component.exports